import ErrorMessageManager from './ErrorMessageManager';

export default ErrorMessageManager;
